import React from "react";
import CompetitionList from "../../Competitions/CompetitionsList";

const Competitions = () => {
  return (
    <>
      <div className={"mb-2"}>
        <CompetitionList />
      </div>
    </>
  );
};

export default Competitions;
